import React, { useState } from 'react';
import Style from './Portfolio.module.scss';
import PortfolioBlock from './PortfolioBlock';
import TestRunDemo from './TestRunDemo';
import SectionHeader from '../ui/SectionHeader';
import { Reveal } from '../ui/Reveal';
import { info } from '../../info/Info';
import { ArrowUpRight } from '../ui/Icons';

export default function Portfolio({ innerRef }) {
    const featured = info.portfolio.find(p => p.featured);
    const rest = info.portfolio.filter(p => !p.featured);
    const [tab, setTab] = useState('demo');

    return (
        <section id="work" ref={innerRef} className={Style.section}>
            <SectionHeader
                request="/work?status=shipped"
                response={`200 OK · ${info.portfolio.length} results`}
                title="Selected work"
            />

            {featured && (
                <Reveal>
                    <div className={Style.featured}>
                        <div className={Style.featuredBody}>
                            <p className={Style.requestLine}>
                                <span className={Style.method}>GET</span> /projects/{featured.slug}
                                <span className={Style.status}>200 OK · {featured.ms}</span>
                            </p>
                            <span className={Style.badge}>{featured.badge}</span>
                            <a
                                href={featured.source}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={Style.featuredTitleLink}
                            >
                                <h3 className={Style.featuredTitle}>{featured.title}</h3>
                            </a>
                            <p className={Style.featuredDesc}>{featured.description}</p>
                            <div className={Style.tech}>
                                {featured.tech.map((t) => <span key={t}>{t}</span>)}
                            </div>
                            <a
                                href={featured.source}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={Style.visit}
                            >
                                visit cognivox-ai.com <ArrowUpRight size={13} />
                            </a>
                        </div>

                        <div className={Style.featuredPane}>
                            <div className={Style.paneBar}>
                                <span /><span /><span />
                                <div className={Style.paneTabs}>
                                    <button
                                        className={tab === 'demo' ? Style.paneTabActive : Style.paneTab}
                                        onClick={() => setTab('demo')}
                                    >
                                        ▶ live demo
                                    </button>
                                    <button
                                        className={tab === 'json' ? Style.paneTabActive : Style.paneTab}
                                        onClick={() => setTab('json')}
                                    >
                                        response.json
                                    </button>
                                </div>
                            </div>
                            {tab === 'json' ? (
                                <pre className={Style.paneCode}>{`{
  "name":    "Cognivox-AI",
  "role":    "founder & engineer",
  "status":  "live",
  "input":   "plain English",
  "output":  "executed API tests",
  "detects": ["drift", "regressions",
              "breaking changes"],
  "healing": "self",
  "uptime":  "99.9%"
}`}</pre>
                            ) : (
                                <TestRunDemo />
                            )}
                        </div>
                    </div>
                </Reveal>
            )}

            <div className={Style.grid}>
                {rest.map((project, index) => (
                    <PortfolioBlock key={project.slug} project={project} delay={(index % 3) * 0.12} />
                ))}
            </div>
        </section>
    );
}
